import {
  Card,
  Row,
  Col,
  Tag,
  Checkbox,
  Button,
  Modal,
  Table,
  Spin,
  Drawer,
  List,
  Space,
  Typography,
} from "antd";
import {
  CheckCircleOutlined,
  CloseOutlined,
  EditOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { CalendarOutlined, DeleteOutlined } from "@ant-design/icons";
import "./invoice-order-summary-card.scss";
import DecimalFormatter from "../../../common/decimal-converter/decimal-converter";
import { checkIsTurkeyKazak } from "../../../util/constantUtility";
import { useStore } from "../../../store/store";
import arrowIconTrukker from "../../../assets/images/arrow-left-trip.svg";
import arrowIconAdeed from "../../../assets/adeed/images/arrow-left-trip.svg";
import { ReactComponent as ClockIcon } from "../../../assets/images/clock-embedded.svg";
import ErrorWarningLine from "../../../assets/images/error-warning-line.svg";
import doubleClick from "../../../assets/images/double_click_success.svg";
import progressIcon from "../../../assets/images/progress_icon.svg";
import pendingIcon from "../../../assets/images/pod_pending_icon.svg";
import invoicedIcon from "../../../assets/images/invoiced_icon.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  getInvoiceOrderTripList,
  uploadPODDocumentForTrips,
} from "../../../service/earning-invoice/earning-invoice";
import FileUploadMultiple from "../../../common/fileupload-mutilpe/file-upload-multiple";
import { DocTypes, EntityTypes } from "../../../constants/commonConstants";
import * as documentService from "./../../../service/documentService";
import Notification from "./../../../service/notification";
import Preview from "../../../common/preview/preview";
import { getThumbnailImagePath } from "../../../util/documentThumbUtility";
import { BrandColors, isAdeed, brandColor } from "../../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const arrowIcon = isAdeed ? arrowIconAdeed : arrowIconTrukker;

const { Text } = Typography;

const InvoiceSummaryCard = ({
  data,
  selected,
  onSelect,
  onDelete,
  isReadOnly = true,
  isDeletable = false,
  accordionType,
}) => {
  const { user } = useStore();
  const { t } = useTranslation();
  const [tripDetailsModalOpen, setTripDetailsModalOpen] = useState(false);
  const [tripLoader, setTripLoader] = useState(false);
  const [podUploadLoader, setPodUploadLoader] = useState(false);
  const [tripDetailsList, setTripDetailsList] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [confirmedFiles, setConfirmedFiles] = useState([]);
  const [isWaitUpload, setIsWaitUpload] = useState(false);
  const [uploadedProgress, setUploadedProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [podDocsModalOpen, setPodDocsModalOpen] = useState(false);
  const [podDocsList, setPodDocsList] = useState([]);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const formatDate = (date) => {
    return dayjs.utc(date).format("DD MMM YYYY");
  };

  const getPodDocName = (doc) => doc?.fileName || doc?.FileName || "";

  const getPodDocUrl = (doc) => doc?.documentPath || doc?.FileURL || "";

  const handlePreviewClick = (doc) => {
    setPreviewFile({
      fileURL: getPodDocUrl(doc),
      fileName: getPodDocName(doc),
    });
    setIsPreviewModalOpen(true);
  };

  const handlePreviewModalCancel = () => {
    setIsPreviewModalOpen(false);
    setPreviewFile(null);
  };

  //single doc opens the preview directly, multiple docs open the list first
  const handleReviewPodClick = (trip) => {
    const podDocs = trip?.podDocs || [];

    if (podDocs?.length === 1) {
      handlePreviewClick(podDocs[0]);
    } else if (podDocs?.length > 1) {
      setPodDocsList(podDocs);
      setPodDocsModalOpen(true);
    }
  };

  const handlePodDocsModalCancel = () => {
    setPodDocsModalOpen(false);
    setPodDocsList([]);
  };

  const handleTripDetailsModalClick = () => {
    fetchTripDetailsList();
    setTripDetailsModalOpen(true);
  };

  const fetchTripDetailsList = () => {
    const payload = {
      orderNumber: data?.orderNumber,
    };
    setTripLoader(true);
    getInvoiceOrderTripList(payload)
      .then((res) => {
        setTripLoader(false);
        if (res.status === 200) {
          setTripDetailsList(res.data.data);
        }
      })
      .catch((err) => {
        setTripLoader(false);
      });
  };

  const uploadPodDocuments = () => {
    const payload = {
      orderNumber: data?.orderNumber,
      tripId: selectedTrip?.tripId,
      status: "Completed",
      documents: confirmedFiles.map((file) => ({
        isInsertUpdate: true,
        isDeleted: false,
        documentPath: file.FileURL,
        documentPathThumb: file.FileThumbURL,
        fileName: file.FileName,
        lastUpdatedBy: user.userName,
        lbDocId: "",
      })),
    };

    setPodUploadLoader(true);

    uploadPODDocumentForTrips(payload)
      .then((res) => {
        if (res.status === 200) {
          Notification.success("Success", "POD uploaded successfully");
          fetchTripDetailsList();
          setOpenDrawer(false);
          setSelectedTrip(null);
          setConfirmedFiles([]);
        }
      })
      .finally(() => {
        setPodUploadLoader(false);
      });
  };

  var config = {
    onUploadProgress: function (progressEvent) {
      debugger;
      console.log(
        `progressEvent.loaded:${Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        )}`,
      );
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );
      setUploadedProgress(percentCompleted);
    },
  };

  const uploadFile = async (fileItem) => {
    const file = fileItem?.file || fileItem;

    console.log("Actual file", file);

    if (
      !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
        file?.type,
      )
    ) {
      Notification.error(t("FILE_UPLOAD_NOT_SUPPORTED"));
      return null;
    }

    if (file.size >= 10000 * 1000) {
      Notification.error(t("FILE_SIZE_ERROR"));
      return null;
    }

    try {
      const form = new FormData();

      form.append("file", file);

      const payload = {
        docType: DocTypes.ORDTRPINF,
        entityType: EntityTypes.Inquiry,
        fileName: file.name,
        docName: file.name?.replace(" ", "_") || "",
        fileData: "",
        fileURL: "",
        fileThumbURL: "",
        fileThumbName: "",
        uniqueID: "",
        totalPartition: 1,
        seq: 1,
        isPathSet: true,
      };

      form.append("details", JSON.stringify(payload));

      setIsWaitUpload(true);

      const response = await documentService.uploadDocumentV2(form, config);

      setIsWaitUpload(false);

      if (response?.data?.status === 200) {
        const uploadedDoc = {
          DocType: response.data.data.docType,
          EntityId: response.data.data.entityId,
          FileName: response.data.data.fileName,
          FileThumbName: response.data.data.fileThumbName,
          FileThumbURL: response.data.data.fileThumbURL,
          FileURL: response.data.data.fileURL,
          docName: file.name,
        };

        Notification.success(t("SUCCESS_KEY"), t("FILE_UPLOADED_SUCCESS"));

        return uploadedDoc;
      }

      return null;
    } catch (error) {
      setIsWaitUpload(false);
      return null;
    }
  };

  const handleOCRConformFileChange = async (newFiles) => {
    setIsUploading(true);

    try {
      const uploadedDocs = [];

      for (const file of newFiles) {
        const uploadedDoc = await uploadFile(file);

        if (uploadedDoc) {
          uploadedDocs.push(uploadedDoc);
        }
      }

      if (uploadedDocs.length) {
        setConfirmedFiles((prev) => [...prev, ...uploadedDocs]);
      }
    } finally {
      setIsUploading(false);
    }
  };

  const handleOCRConfirmFileDelete = (fileNameToDelete) => {
    setConfirmedFiles((prev) =>
      prev.filter((file) => file.FileName !== fileNameToDelete),
    );
  };

  const getPodPendingBackground = () => {
    if (accordionType !== "PODPending") return undefined;

    const days = data?.daysSinceMoveDate || 0;

    if (days <= 30) {
      return "linear-gradient(95.65deg, #EFFFE3 4.6%, #FDFFEE 95.1%)";
    }

    if (days <= 90) {
      return "linear-gradient(275.77deg, var(--brand-50, #FFF5E3) 2.8%, var(--brand-tint-soft, #FFF8EC) 96.15%)";
    }

    return "linear-gradient(102.91deg, #FFF7F7 15.45%, #FDF2F2 78.58%)";
  };

  return (
    <>
      <Card
        className={`invoice-summary-card ${
          selected ? "invoice-summary-card-selected" : ""
        }`}
        style={{
          background: getPodPendingBackground(),
        }}
      >
        {/* Top Row */}
        <Row justify="space-between" align="middle">
          {/* Left */}
          <div className="header-left-block">
            <div className="invoice-summary-card-id">{data?.orderNumber}</div>
            <div className="trips-tag">
              <span className="trip-tag-label">{t("INV_UPL_SUMMARY_TRIPS_LB")}</span>
              <span className="value">
                {" "}
                {String(data?.totalTrips || 0).padStart(2, "0")}
              </span>
            </div>
          </div>

          {/* Right */}
          <Row align="middle" gutter={12}>
            <Col>
              <div className="invoice-summary-card-date">
                <span>{t("INV_UPL_SUMMARY_MOVE_DATE_LB")}</span>
                <CalendarOutlined />
                <span>{data?.moveDate ? formatDate(data?.moveDate) : "-"}</span>
              </div>
            </Col>

            {!isReadOnly && data?.isSelectable && (
              <Col>
                <Checkbox
                  disabled={!data?.isSelectable}
                  checked={selected}
                  onChange={(e) => onSelect(data.orderNumber, e.target.checked)}
                />
              </Col>
            )}
            {/* deletable */}
            {isDeletable && (
              <Col>
                <DeleteOutlined
                  style={{
                    color: "var(--text-danger, #FF0606)",
                    cursor: "pointer",
                    fontSize: "18px",
                  }}
                  onClick={() => onDelete?.(data)}
                />
              </Col>
            )}
          </Row>
        </Row>

        {/* Middle Stats */}
        <Row className="invoice-summary-card-stats" gutter={16}>
          {/* <Col span={6}>
            <div className="label">{t("INV_UPL_SUMMARY_TOTAL_TRIPS_LB")}</div>
            <div className="value">{data?.totalTrips}</div>
          </Col> */}

          <Col span={8}>
            <div className="label">{t("INV_UPL_SUMMARY_FREIGHT_COST_LB")}</div>
            <div className="value">
              {data?.baseCost?.currency}&nbsp;
              {data?.baseCost?.amount ? (
                <DecimalFormatter
                  amount={data?.baseCost?.amount}
                  country={
                    checkIsTurkeyKazak(user?.operatingCountry)
                      ? "TRY"
                      : data?.baseCost?.currency
                  }
                  flag={false}
                  isShowDecimal={true}
                />
              ) : (
                "0"
              )}
            </div>
          </Col>

          <Col span={8}>
            <div className="label">
              {t("INV_UPL_SUMMARY_ADDITIONAL_CHARGES_LB")}
            </div>
            <div className="value">
              {data?.actualCost?.currency}&nbsp;
              {data?.actualCost?.amount ? (
                <DecimalFormatter
                  amount={data?.actualCost?.amount}
                  country={
                    checkIsTurkeyKazak(user?.operatingCountry)
                      ? "TRY"
                      : data?.actualCost?.currency
                  }
                  flag={false}
                  isShowDecimal={true}
                />
              ) : (
                "0"
              )}
            </div>
          </Col>

          <Col span={8}>
            <div className="label">
              {t("INV_UPL_SUMMARY_TOTAL_EARNINGS_LB")}
            </div>
            <div className="value highlight">
              {data?.totalEarning?.currency}&nbsp;
              <DecimalFormatter
                amount={data?.totalEarning?.amount}
                country={
                  checkIsTurkeyKazak(user?.operatingCountry)
                    ? "TRY"
                    : data?.totalEarning?.currency
                }
                flag={false}
                isShowDecimal={true}
              />
            </div>
            {data?.totalEarning?.amountInSupplierCurrency > 0 &&
              data?.totalEarning?.currency !==
                data?.totalEarning?.supplierCurrency && (
                <div className="sub highlight-sub">
                  ({data?.totalEarning?.supplierCurrency}{" "}
                  <DecimalFormatter
                    amount={data?.totalEarning?.amountInSupplierCurrency}
                    country={
                      checkIsTurkeyKazak(user?.operatingCountry)
                        ? "TRY"
                        : data?.totalEarning?.supplierCurrency
                    }
                    flag={false}
                    isShowDecimal={true}
                  />
                  )
                </div>
              )}
          </Col>
        </Row>

        {/* Bottom Row */}
        <hr
          style={{
            border: "none",
            borderTop: "2px dotted var(--border-strong, #999)",
            margin: "16px 0",
          }}
        />
        <Row justify="space-between" className="invoice-summary-card-footer">
          <Col span={24}>
            <Row justify="space-between" align="middle">
              {accordionType !== "PODPending" && (
                <Tag
                  className={
                    data?.statusValue === "Invoiced"
                      ? "invoiced-tag"
                      : data?.statusValue === "POD Pending"
                        ? "status-tag-pending"
                        : accordionType === "InvoiceInReview"
                          ? "invoice-review"
                          : "status-tag"
                  }
                >
                  {/* Icon Logic */}
                  {data?.statusValue === "POD Pending" && (
                    <img src={pendingIcon} height={13} width={13} alt="" />
                  )}

                  {data?.statusValue === "Invoicing in Progress" && (
                    <img src={progressIcon} height={15} width={15} alt="" />
                  )}

                  {data?.statusValue === "POD Uploaded" && (
                    <img src={doubleClick} height={20} width={20} alt="" />
                  )}

                  {data?.statusValue === "Invoiced" && (
                    <img src={invoicedIcon} height={18} width={18} alt="" />
                  )}

                  {data?.statusValue}
                </Tag>
              )}
              {accordionType === "PODPending" && (
                // <Col className="company-name">{t("INV_POD_UPLOAD_MGS")}</Col>
                <Col className="company-name">
                  {t("INV_POD_UPLOAD_FULL_TEXT_MGS")}
                </Col>
              )}
              <Button
                type="link"
                style={{
                  // color: "#FF833C",
                  color: `${accordionType === "PODPending" ? "#E73B19" : BrandColors.primary}`,
                  fontWeight: "bold",
                  padding: "4px 8px",
                  border: "0.5px solid #E73B19",
                  gap: "4px",
                }}
                onClick={handleTripDetailsModalClick}
              >
                {t("INV_UPL_SUMMARY_TRIP_DETAIL_TITLE")}
                {/* <img
                  src={arrowIcon}
                  height={20}
                  width={20}
                  style={{ marginBottom: "-2px", marginLeft: "-4px" }}
                  alt="arrow"
                /> */}
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.83335 3.08219C4.83335 3.08219 7.74999 5.23026 7.75 5.99886C7.75001 6.76746 4.83333 8.91553 4.83333 8.91553"
                    stroke="currentColor"
                    stroke-width="1.16667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Row>
          </Col>
        </Row>
      </Card>

      <Modal
        title={`${t("INV_UPL_SUMMARY_TRIP_DETAIL_TITLE")} (${tripDetailsList?.length || 0})`}
        open={tripDetailsModalOpen}
        onCancel={() => setTripDetailsModalOpen(false)}
        footer={null}
        width={800}
      >
        <div style={{ padding: 16 }}>
          <Spin spinning={tripLoader} tip={t("INV_UPL_SUMMARY_LOAD_TRIPS_LDR")}>
            {tripDetailsList?.length > 0 ? (
              tripDetailsList.map((trip) => {
                const status =
                  trip?.podStatus === "PODRejected"
                    ? {
                        text: t("INV_UPL_SUMMARY_POD_REJECTED_STATUS"),
                        textColor: "#E73B19",
                        bgColor: "#FFF7F7",
                      }
                    : trip?.podStatus === "PODUploaded"
                      ? {
                          text: t("INV_UPL_SUMMARY_POD_UPLOADED_STATUS"),
                          textColor: "#0C9E42",
                          bgColor: "#DADEE34D",
                        }
                      : trip?.podStatus === "PODVerificationPending"
                        ? {
                            text: t("INV_UPL_SUMMARY_POD_VERIF_PENDING_STATUS"),
                            textColor: brandColor(BrandColors.primaryDark, "#f48c04"),
                            bgColor: "#DADEE34D",
                          }
                        : {
                            text: t(
                              "INV_UPL_SUMMARY_POD_UPLOAD_PENDING_STATUS",
                            ),
                            textColor: "#2C3A4BE5",
                            bgColor: "#DADEE34D",
                          };

                return (
                  <Card
                    key={trip.tripId}
                    style={{ marginBottom: 16 }}
                    size="small"
                    className="pod-upload-card"
                  >
                    <Row
                      justify="space-between"
                      align="middle"
                      className="card-top-row"
                    >
                      <Col span={10}>
                        <span className="data-head">
                          {t("INV_UPL_SUMMARY_DRIVER_NAME")}
                        </span>{" "}
                        <br />
                        <span className="data-value">
                          {trip?.driverName || "-"}
                        </span>
                      </Col>

                      <Col span={10}>
                        <span className="data-head">
                          {t("INV_UPL_SUMMARY_TRIP_PLT_NO")}
                        </span>
                        <br />
                        <span className="data-value">
                          {trip?.assetRegistrationNumber || "-"}
                        </span>
                      </Col>
                    </Row>

                    <div
                      className="footer-row"
                      style={{ backgroundColor: status.bgColor }}
                    >
                      <Row justify="space-between" align="middle">
                        <Col flex="auto">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              color: status.textColor,
                              fontWeight: 600,
                            }}
                          >
                            {trip?.podStatus === "PODUploaded" ? (
                              <CheckCircleOutlined />
                            ) : trip?.podStatus === "PODRejected" ? (
                              <img src={ErrorWarningLine} alt="Rejected" />
                            ) : (
                              <ClockIcon />
                            )}
                            <span>{status.text}</span>
                          </div>
                        </Col>

                        {trip?.podStatus === "PODUploaded" ||
                        trip?.podStatus === "PODVerificationPending" ? (
                          <Col>
                            <Button
                              type="link"
                              className="upload-button"
                              onClick={() => handleReviewPodClick(trip)}
                            >
                              {t("INV_UPL_SUMMARY_POD_REVIEW_BTN", {
                                defaultValue: "Review POD",
                              })}
                              {trip?.podDocs?.length > 0
                                ? ` (${trip?.podDocs?.length})`
                                : ""}
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.609 7.05731L8.74701 4.19531L7.80434 5.13798L9.99968 7.33331H3.33301V8.66665H9.99968L7.80434 10.862L8.74701 11.8046L11.609 8.94265C11.859 8.69261 11.9994 8.35353 11.9994 7.99998C11.9994 7.64643 11.859 7.30735 11.609 7.05731Z"
                                  fill={brandColor(BrandColors.primaryHover, "#FFB940")}
                                />
                              </svg>
                            </Button>
                          </Col>
                        ) : (
                          <Col>
                            <Button
                              type="link"
                              className="upload-button"
                              onClick={() => {
                                setSelectedTrip(trip);
                                setOpenDrawer(true);
                              }}
                            >
                              {t("INV_UPL_SUMMARY_POD_UPLOAD_BTN")}
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.609 7.05731L8.74701 4.19531L7.80434 5.13798L9.99968 7.33331H3.33301V8.66665H9.99968L7.80434 10.862L8.74701 11.8046L11.609 8.94265C11.859 8.69261 11.9994 8.35353 11.9994 7.99998C11.9994 7.64643 11.859 7.30735 11.609 7.05731Z"
                                  fill={brandColor(BrandColors.primaryHover, "#FFB940")}
                                />
                              </svg>
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </Card>
                );
              })
            ) : (
              <div style={{ textAlign: "center", padding: 20 }}>
                {/* No Trips Available */}
              </div>
            )}
          </Spin>
        </div>
      </Modal>

      {/*  */}
      <Drawer
        className="drawer-upload"
        title={
          <>
            <div className="drawer-title">
              {t("INV_UPL_SUMMARY_POD_UPLOAD_TITLE")}
              <div>
                <Button
                  icon={<CloseOutlined />}
                  disabled={isUploading}
                  type="text"
                  onClick={() => {
                    setOpenDrawer(false);
                    setSelectedTrip(null);
                    setConfirmedFiles([]);
                  }}
                  style={{ fontSize: "16px" }}
                />
              </div>
            </div>
          </>
        }
        onClose={() => {
          setOpenDrawer(false);
          setSelectedTrip(null);
        }}
        closable={false}
        open={openDrawer}
        styles={{
          header: {
            padding: "0",
            border: "none",
          },
          body: {
            padding: "0",
            position: "relative",
          },
        }}
      >
        <>
          <div className="drawer-upload-body">
            <span style={{ fontSize: "14px", color: "var(--text, #000000)" }}>
              {t("INV_UPL_SUMMARY_POD_UPLOAD_MSG")}
            </span>
            <Spin
              spinning={isUploading}
              tip={t("INV_UPL_SUMMARY_POD_UPLOAD_LOADER")}
            >
              <FileUploadMultiple
                onChange={handleOCRConformFileChange}
                uploadedFiles={confirmedFiles}
                onDelete={handleOCRConfirmFileDelete}
                allowSingleFile={true}
              />
            </Spin>
          </div>
          <Row
            justify="center"
            gutter={8}
            style={{
              width: "100%",
              bottom: 0,
              position: "absolute",
            }}
          >
            <Col span={12}>
              <Button
                disabled={isUploading || podUploadLoader}
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="skip-button"
                onClick={() => {
                  setOpenDrawer(false);
                  setConfirmedFiles([]);
                }}
              >
                {t("INV_UPL_SUMMARY_POD_UPLOAD_CANCEL")}
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="submit-button"
                onClick={uploadPodDocuments}
                disabled={
                  !confirmedFiles?.length || podUploadLoader || isUploading
                }
                loading={podUploadLoader}
              >
                {t("INV_UPL_SUMMARY_POD_UPLOAD_SUBMIT")}
              </Button>
            </Col>
          </Row>
        </>
      </Drawer>

      {/* POD documents list, shown when a trip has more than one document */}
      <Modal
        title={t("INV_UPL_SUMMARY_POD_DOCS_TITLE", {
          defaultValue: "POD Documents",
        })}
        open={podDocsModalOpen}
        onCancel={handlePodDocsModalCancel}
        centered
        footer={null}
        width={520}
      >
        <List
          className="pod-docs-list"
          dataSource={podDocsList}
          renderItem={(doc, index) => (
            <List.Item
              key={doc?.lbDocId || index}
              className="pod-docs-list-item"
              onClick={() => handlePreviewClick(doc)}
            >
              <Space size={12} align="center">
                <Text className="pod-doc-index">{index + 1}.</Text>
                <img
                  src={getThumbnailImagePath(
                    doc?.documentPathThumb || getPodDocUrl(doc),
                  )}
                  alt="preview"
                  className="pod-docs-thumb"
                />
                <Text className="pod-doc-name" ellipsis={{ tooltip: true }}>
                  {getPodDocName(doc)}
                </Text>
              </Space>
            </List.Item>
          )}
        />
      </Modal>

      {/* POD preview */}
      <Modal
        className="pod-preview-modal"
        title="Preview"
        open={isPreviewModalOpen}
        onCancel={handlePreviewModalCancel}
        centered
        footer={null}
      >
        {previewFile?.fileURL && (
          <Preview
            uploadedfile={previewFile.fileURL}
            uploadedFileName={previewFile.fileName}
          />
        )}
      </Modal>
    </>
  );
};

export default InvoiceSummaryCard;
